import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-layout-main" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "基本资料", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "修改密码", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "退出登录", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_sider = _resolveComponent("app-sider")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_body = _resolveComponent("app-body")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-layout", _ctx.layoutClassName])
  }, [
    (_ctx.sidebar.opened && _ctx.screenSize === 'screen-xs')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickOutside && _ctx.handleClickOutside(...args))),
          class: "app-layout-sider-mask"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_app_sider, {
      systemName: _ctx.SYSTEM_INFO_ENUM.SYSTEM_NAME,
      menus: _ctx.menus,
      sidebar: _ctx.sidebar,
      "is-collapse": _ctx.isCollapse,
      logo: _ctx.LogoIcon
    }, null, 8, ["systemName", "menus", "sidebar", "is-collapse", "logo"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_app_header, {
        opened: _ctx.sidebar.opened,
        "account-data": _ctx.accountData,
        onToggleSidebar: _ctx.handleToggleSideBar
      }, {
        "dropdown-menu": _withCtx(() => [
          _createVNode(_component_el_dropdown_item, { disabled: "" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_dropdown_item, { disabled: "" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: _ctx.handleLogout
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["opened", "account-data", "onToggleSidebar"]),
      (_openBlock(), _createBlock(_component_router_view, { key: _ctx.viewKey }, {
        default: _withCtx(({ Component }) => [
          _createVNode(_component_app_body, null, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })),
      _createVNode(_component_app_footer)
    ])
  ], 2))
}